import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { OrderModel } from '../../models/orders.model';
import { BehaviorSubject, catchError, map, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  endpoint: string = environment.apiUrl;
  nextToken = new BehaviorSubject<string>('');
  constructor(private http: HttpClient) {}

  getOrders(
    petitionerId: string,
    status: string,
    nextToken?: string
  ): Observable<OrderModel[]> {
    let url = `${this.endpoint}orders?petitioner_id=${petitionerId}&active=${status}`;
    if (nextToken) {
      url = `${url}&next_token=${nextToken}`;
    }
    return this.http.get<{ data: OrderModel[]; next_token: string }>(url).pipe(
      map((response) => {
        this.nextToken.next(response.next_token ?? null);
        const data = response.data ?? [];
        if (data?.length > 0) {
          data.map((order) => {
            order.totalM3 = order.materials.reduce(
              (total, material) => total + parseInt(material.volume),
              0
            );
            return order;
          });
        }
        return data;
      })
    );
  }

  rejectOrder(orderId: string): Observable<any> {
    let url = `${this.endpoint}order?order_id=${orderId}&action=reject`;
    return this.http.put(url, {});
  }

  updateOrder(orderUdate: any, orderId: string): Observable<string> {
    const url = `${this.endpoint}order?order_id=${orderId}`;

    return this.http
      .patch<{ success: boolean; message: string }>(url, orderUdate)
      .pipe(
        map((response) => {
          if (response.success) {
            return response.message;
          } else {
            throw new Error(response.message);
          }
        }),
        // Manejo de errores
        catchError((error) => {
          if (error.status === 400 && error.error?.message) {
            // Manejar el caso en el que la orden no existe
            return throwError(() => new Error(error.error.message));
          }
          return throwError(
            () => new Error('Ocurrió un error al actualizar la orden.')
          );
        })
      );
  }
}
